<script>
  import { praxi, state, taxi } from "../js/stores.js"
  import { onMount } from "svelte"
  import { gsap } from "gsap"

  import { _ } from "svelte-i18n"

  let scoreMsg = "",
    lastHighScoreMsg = ""

  function getHighScore() {
    if (localStorage.getItem("highScore")) {
      return JSON.parse(localStorage.getItem("highScore"))
    } else {
      return {
        score: 0,
        date: "",
      }
    }
  }

  function setHighScore(score) {
    let date = new Date().toLocaleDateString("el-GR")
    let time = new Date().toLocaleTimeString("el-GR", {
      hour12: false,
      hour: "numeric",
      minute: "numeric",
    })
    let scoreData = {
      score: score,
      date: date + " " + time,
    }
    localStorage.setItem("highScore", JSON.stringify(scoreData))
  }

  onMount(() => {
    let score = $state.scorePositive - $state.scoreNegative
    const cheatThreshold = 160
    let seconds =
      $state.seconds > cheatThreshold ? $state.seconds : cheatThreshold
    let scoreTime = Math.round((1000 / seconds) * 20 + 50)
    let scoreTotal = score + scoreTime

    // insights.track({
    //   id: "score",
    //   parameters: {
    //     answerScore: score,
    //     timeScore: scoreTime,
    //     totalScore: scoreTotal,
    //   },
    // })

    plausible("Finale", {
      props: {
        answerScore: score,
        timeScore: scoreTime,
        totalScore: scoreTotal,
        taxi: $taxi,
        praxi: $praxi,
      },
    })

    const data = getHighScore()

    if (data.score > 0)
      lastHighScoreMsg = $_("lastHighScoreMsg", {
        values: { score: data.score, date: data.date },
      })

    if (scoreTotal > data.score) {
      setHighScore(scoreTotal)
      scoreMsg = $_("newHighScore")
    } else if (scoreTotal == data.score) {
      scoreMsg = $_("tieHighScore")
    } else {
      scoreMsg = ""
    }

    gsap.to("#score-answers", {
      duration: 2,
      innerText: score,
      snap: { innerText: 1 },
      ease: "power1",
      onComplete: () => {
        gsap.to("#score-time", {
          duration: 2,
          innerText: scoreTime,
          snap: { innerText: 1 },
          ease: "power1",
          onComplete: () => {
            gsap.to("#score-total", {
              duration: 2,
              innerText: scoreTotal,
              snap: { innerText: 1 },
              ease: "power1",
            })
          },
        })
      },
    })
  })
</script>

<div id="score-container">
  <table>
    <tr class="subscore">
      <td class="label">{$_("answerPoints")}</td>
      <td class="num"><span id="score-answers">0</span></td>
    </tr>
    <tr class="subscore">
      <td class="label">{$_("timePoints")}</td>
      <td class="num"><span id="score-time">0</span></td>
    </tr>
    <tr class="total">
      <td class="label">{$_("totalPoints")}</td>
      <td class="num"><span id="score-total">0</span></td>
    </tr>
  </table>

  <div class="score-info new-high">{scoreMsg}</div>
  <div class="score-info">{lastHighScoreMsg}</div>
</div>

<style>
  #score-container {
    margin: 20px auto;

    font-size: 1.5rem;
    color: white;
    background: rgba(0, 0, 0, 0.6);
    padding: 20px 50px;
    border-radius: 20px;
  }

  td.label {
    text-align: right;
  }
  td {
    padding: 10px 0;
  }

  td.num {
    min-width: 70px;
    text-align: right;
  }

  .total .label {
    color: #ff7940;
  }
  .total .num {
    color: #ff7940;
  }

  .score-info {
    font-size: 0.8rem;
    text-align: center;
  }

  .new-high {
    color: #97dd77;
    margin: 8px 0;
  }

  @media (max-width: 600px) {
    #score-container {
      margin: 20px auto;

      font-size: 1.2rem;
      padding: 10px 25px;
      border-radius: 20px;
    }
  }
</style>
